if (typeof Promise.withResolvers === "undefined") {
  Promise.withResolvers = function <T>() {
    let resolve: ((v: T | PromiseLike<T>) => void) | undefined = undefined;
    let reject: ((e: unknown) => void) | undefined = undefined;

    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });

    return { promise, resolve: resolve!, reject: reject! };
  };
}
